import { create } from "zustand";
import { persist } from "zustand/middleware";
import { uuidv7 } from "uuidv7";

interface TerminalState {
  deviceId: string;
  userCode: string | null;
  restaurantCode: string | null;
  restaurantName: string | null;
  platform: "web" | "desktop";

  // Printer settings
  printerType: "network" | "mock";
  printerIp: string;
  printerPort: number;
  hasDrawer: boolean;

  // POS settings
  posType: "network" | "mock";
  posIp: string;
  posPort: number;
  posSerial: string;

  setRestaurant: (code: string, name: string) => void;
  setUserCode: (code: string | null) => void;
  resetTerminal: () => void;
  setPlatform: (platform: "web" | "desktop") => void;
  updateSettings: (
    settings: Partial<
      Pick<
        TerminalState,
        | "printerType"
        | "printerIp"
        | "printerPort"
        | "hasDrawer"
        | "posType"
        | "posIp"
        | "posPort"
        | "posSerial"
      >
    >,
  ) => void;
}

export const useTerminalStore = create<TerminalState>()(
  persist(
    (set) => ({
      deviceId: uuidv7(),
      userCode: null,
      restaurantCode: null,
      restaurantName: null,
      platform: "web",

      // Default connection settings
      printerType: "mock",
      printerIp: "192.168.1.100",
      printerPort: 9100,
      hasDrawer: true,

      posType: "mock",
      posIp: "192.168.1.150",
      posPort: 25000,
      posSerial: "ING-88776655",

      setRestaurant: (code, name) =>
        set({
          restaurantCode: code,
          restaurantName: name,
        }),
      setUserCode: (userCode) =>
        set({
          userCode,
        }),
      resetTerminal: () =>
        set({
          restaurantCode: null,
          restaurantName: null,
          userCode: null,
        }),
      setPlatform: (platform) =>
        set({
          platform,
        }),
      updateSettings: (settings) =>
        set((state) => ({
          ...state,
          ...settings,
        })),
    }),
    {
      name: "terminal-storage",
    },
  ),
);
